<template>
	<div>
		<table class="users-list-table table table-primary table-striped">
			<thead>
				<tr>
					<th width="5%">
						<label class="input-checkbox-container">
							<input
								type="checkbox"
								class="input-checkbox"
								v-model="selectAll"
							/>
							<span></span>
						</label>
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('name')"
						@click="changeSorting('name')"
					>
						Name
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('email')"
						@click="changeSorting('email')"
					>
						Email
					</th>
					<th
						width="6%"
						class="th-sort text-left"
						:class="sortClass('username')"
						@click="changeSorting('username')"
					>
						Username
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('phone')"
						@click="changeSorting('phone')"
					>
						Phone
					</th>
					<th
						width="5%"
						class="th-sort text-left"
						:class="sortClass('is_phone_verified')"
						@click="changeSorting('is_phone_verified')"
					>
						Phone Verification
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('owner_type')"
						@click="changeSorting('owner_type')"
					>
						Owner Type
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('source_type')"
						@click="changeSorting('source_type')"
					>
						Source Type
					</th>
					<th
						width="5%"
						class="th-sort text-left"
						:class="sortClass('is_active')"
						@click="changeSorting('is_active')"
					>
						Status
					</th>
					<th
						width="10%"
						class="th-sort text-center"
						:class="sortClass('is_active')"
						@click="changeSorting('is_active')"
					>
						Verification
					</th>
					<th
						width="10%"
						class="th-sort text-center"
						:class="sortClass('is_active')"
						@click="changeSorting('is_active')"
						v-if="activePage === 'seller'"
					>
						City
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('expired_date')"
						@click="changeSorting('expired_date')"
					>
						Expired Date
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('created_at')"
						@click="changeSorting('created_at')"
					>
						Join Date
					</th>
					<th width="10%" class="">
						{{ $t('Private Order Feature') }}
					</th>
					<th
						width="10%"
						class="th-sort text-left"
					>
						Actions
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in items" :key="item._id">
					<td class="align-middle">
						<label class="input-checkbox-container">
							<input
								type="checkbox"
								class="input-checkbox"
								:value="item._id"
								v-model="selectedItems"
							/>
							<span></span>
						</label>
					</td>
					<td>
						<div
							class="user__name d-flex text-bold flex-column"
						>
							<div
								class="user__image"
								:style="{ backgroundImage: `url(${item.picture})` }"
								v-if="item.picture"
							></div>
							<span class="text-primary cursor-pointer" @click="openUserProfile(item)">{{ item.name }}</span>
							<div class="small text-muted mt-1" v-if="item.payment_type">
								Payment: <span class="font-weight-bold text-capitalize text-dark">{{ item.payment_type }}</span>
							</div>
						</div>
					</td>
					<td>
						<div class="user__email d-flex align-items-center">
							<a :href="`mailto:${item.email}`" target="_blank">{{
								item.email
							}}</a>
						</div>
						<div class="d-flex align-items-center mt-1">
							<div
								class="user__id"
								v-tooltip="'User ID'">
								{{ item._id }}
							</div>
							<span class="cursor-pointer text-primary ml-1" v-tooltip="'Copy User ID'" @click="copyUserId(item)">
								<i class="bi bi-clipboard"></i>
							</span>
						</div>

						<!-- Service Fee Config -->
						<div class="d-flex align-items-center mt-2" v-if="item && item.fee_config && item.fee_config.type && item.fee_config.value">
							<div class="d-flex flex-column">
								<label for="" class="mb-0">
									<b class="mb-0">Service Fee</b>
								</label>
								<div class="text-capitalize">
									<template v-if="item && item.fee_config && item.fee_config.type">
										Type: {{ item.fee_config.type || '-' }}
									</template>
								</div>
								<div v-if="item && item.fee_config && item.fee_config.value">
									Value:
									<template v-if="item && item.fee_config && item.fee_config.type === 'fixed'">
										{{ formatMoney(item.fee_config.value) || '-' }}
									</template>
									<template v-if="item.fee_config.type === 'percentage'">{{ item.fee_config.value || '-' }}% from total product price</template>
								</div>
							</div>
						</div>
						<div v-else>
							<b class="text-muted">Use default service fee</b>
						</div>
					</td>
					<td>
						<div class="user__username">{{ item.username }}</div>
					</td>
					<td>
						<div class="user__phone">{{ item.phone }}</div>
						<div class="d-flex">
							<button
								type="button"
								class="submission-action active submission-action-chat mr-1"
								v-tooltip="$t('Follow-Up 1')"
								@click="followUp(item, 0)"
								>
								<i class="material-icons md-18">phone</i>
							</button>
							<button
								type="button"
								class="submission-action active submission-action-chat mr-1"
								v-tooltip="$t('Follow-Up 2')"
								@click="followUp(item, 1)">
								<i class="material-icons md-18">phone</i>
							</button>
						</div>
					</td>
					<td>
						<div
							class="user__phone_verification"
						>
							<div class="status-pill success" v-if="item.is_phone_verified">
								Verified
							</div>
							<div class="status-pill" v-else>
								Not Verified
							</div>
						</div>
					</td>
					<td>
						<div class="user__role">{{ item.owner_type == 'dropshipper' ? 'Seller' :  item.owner_type}}</div>
					</td>
					<td>
						<div class="text-capitalize">{{ formatSourceType(item.source_type) }}</div>
					</td>
					<td>
						<div class="user__status">
							<div class="status-pill success" v-if="item.is_active">
								Active
							</div>
							<div class="status-pill" v-if="!item.is_active">
								Inactive
							</div>
						</div>
					</td>
					<td class="text-center">
						<div v-html="getIdentityDisplayStatus(item)" />
					</td>
					<td v-if="activePage === 'seller'">
						<div
							class="user_city"
						>
							{{ sellerCity(item) }}
						</div>
					</td>
					<td>
						<div class="user__expired_date">
							<template v-if="!item.expired_date">
								<span class="text-danger font-weight-bold">Expired</span>
							</template>
							<template v-else-if="isUserExpired(item)">
								<span class="text-danger font-weight-bold" :title="`Expired on: ${formatExpiredDate(item.expired_date)}`">
									Expired
								</span>
								<div class="small text-muted">{{ formatExpiredDate(item.expired_date) }}</div>
							</template>
							<template v-else>
								<span>{{ formatExpiredDate(item.expired_date) }}</span>
							</template>
						</div>
					</td>
					<td>
						<div
							class="user__date"
							:title="formatDateWithTime(item.created_at)"
						>
							{{ formatDate(item.created_at) }}
						</div>
					</td>
					<td class="text-center">
						<PrivateOrderColumn :item="item" />
					</td>
					<td>
						<div class="btn-group">
							<button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" data-boundary="window">
								{{ $t('Action') }}
							</button>
							<div class="dropdown-menu">
								<button
									type="button"
									class="dropdown-item"
									@click="editUserEmail(item)"
								>{{ $t('Change Email') }}</button>
								<button
									type="button"
									class="dropdown-item"
									@click="changeExpiredDate(item)"
								>
									{{ $t('Change Expired Date') }}
								</button>
								<button
									type="button"
									class="dropdown-item"
									@click="verifUser(item)"
									:disabled="!isVerificationEnabled(item)"
								>{{ $t('Verification') }}</button>
								<button
									type="button"
									class="dropdown-item"
									@click="openSellerConnection(item)"
								>{{ $t('Connection') }}</button>
								<button
									type="button"
									class="dropdown-item"
									@click="recreateOOAccount(item)"
								>
									{{ $t('Resend Create Account OO') }}
								</button>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { sanitizeHtml, copyToClipboard, formatMoney } from '@/lib/helper';
import OOAccountAPI from '@/api/oo-account';
import PrivateOrderColumn from '@/components/PrivateOrderColumn.vue';

export default {
	name: 'UsersTableOwner',
	props: {
		items: {
			type: Array,
		},
		activePage: {
			type: String,
		},
	},
	components: {
		PrivateOrderColumn,
	},
	data() {
		return {
			selectedItems: [],
			sort_by: 'created_at',
			sort: 'asc',
		};
	},
	watch: {
		selectedItems(val) {
			return this.$emit('selectedItems', val);
		},
	},
	methods: {
		formatMoney,
		sellerCity(item) {
			return item?.store?.shipping?.origin?.city?.name ?? '-';
		},
		getIdentityDisplayStatus(user) {
			let displayStatus = '-';
			switch (this.getIdentityStatus(user)) {
			case 'requested':
				displayStatus = '<div class="status-pill warning">Requested</div>';
				break;
			case 'skipped':
				displayStatus = '<div class="status-pill warning">Skipped</div>';
				break;
			case 'rejected':
				displayStatus = '<div class="status-pill danger">Rejected</div>';
				break;
			case 'approved':
				displayStatus = '<div class="status-pill success">Approved</div>';
				break;
			default:
				break;
			}
			return sanitizeHtml(displayStatus);
		},
		getIdentityStatus(user) {
			let status = '';
			if (user.identity !== undefined && user.identity.status !== undefined) {
				status = user.identity.status;
			}
			return status;
		},
		followUp(user, type) {
			const item = {
				data_user: user,
				data_type: type,
			};
			return this.$emit('followUp', item);
		},
		formatDateWithTime(date) {
			return this.moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		formatDate(date) {
			return this.moment(date).format('DD-MM-YYYY');
		},
		formatSourceType(sourceType) {
			return !sourceType ? 'Ostock' : sourceType;
		},
		editUserEmail(user) {
			return this.$emit('editUserEmail', user);
		},
		changeExpiredDate(user) {
			return this.$emit('change-expired-date', user);
		},
		isUserExpired(user) {
			if (!user.expired_date) return true;
			const expiredTime = new Date(user.expired_date).getTime();
			const nowTime = new Date().getTime();
			return expiredTime < nowTime;
		},
		formatExpiredDate(date) {
			if (!date) return '-';
			const expiredDate = this.moment(date);
			const years = expiredDate.diff(this.moment(), 'years');
			if (years > 50) {
				return 'Lifetime';
			}
			return expiredDate.format('DD MMM YYYY');
		},
		verifUser(user) {
			return this.$emit('verifUser', user);
		},
		isVerificationEnabled(user) {
			const status = this.getIdentityStatus(user);
			return status === 'requested'
				|| status === 'rejected'
				|| status === 'approved'
				|| status === 'skipped'
				|| user.owner_type === 'dropshipper';
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		changeSorting(key) {
			const isSame 	= this.sort_by === key;
			this.sort_by 	= key;
			const sort 		= isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort 		= sort;
			const item = {
				sort_by: this.sort_by,
				sort: this.sort,
			};
			return this.$emit('sorting', item);
		},
		openUserProfile(user) {
			if (user.owner_type === 'supplier') {
				this.$emit('supplier-profile', user);
			} else {
				this.$emit('seller-profile', user);
			}
		},
		copyUserId(user) {
			copyToClipboard(user?._id);

			this.$notify({
				group: 'app',
				title: 'User ID Copied',
				text: user?._id,
				type: 'success',
			});
		},
		openSellerConnection(user) {
			return this.$emit('seller-connection', user);
		},
		recreateOOAccount(user) {
			const params = {
				user_id: user._id,
			};

			const callback = (res) => {
				const isError = res?.error;
				const message = res?.message;

				if (isError) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed',
						text: message,
					});
				} else {
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Success',
						text: 'Create OO account success.',
					});
				}
			};
			const errorCallback = (error) => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Create OO Account Error',
					text: error.response.data.message,
				});
			};

			OOAccountAPI.create(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		selectAll: {
			get() {
				return this.items
					? this.selectedItems.length === this.items.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.items.forEach((item) => {
						selected.push(item._id);
					});
				}
				this.selectedItems = selected;
			},
		},
	},
};
</script>
